<nav class="admin-nav" [attr.aria-label]="'settings.navigation.adminAriaLabel' | translate">
  <div class="admin-nav__top">
    <header class="admin-nav__header">
      <h2>{{ 'settings.navigation.adminTitle' | translate }}</h2>
    </header>

    @if (supportItems().length > 0) {
      <section class="admin-nav__section" [attr.aria-label]="'settings.navigation.admin.support.title' | translate">
        <h3 class="admin-nav__section-title">{{ 'settings.navigation.admin.support.title' | translate }}</h3>
        @for (item of supportItems(); track item.labelKey) {
          <a class="admin-nav__item" [routerLink]="item.route" routerLinkActive="admin-nav__item--active"
            [routerLinkActiveOptions]="{ exact: true }">
            <span>{{ item.labelKey | translate }}</span>
          </a>
        }
      </section>
    }

    @if (systemItems().length > 0) {
      <section class="admin-nav__section" [attr.aria-label]="'settings.navigation.admin.system.title' | translate">
        <h3 class="admin-nav__section-title">{{ 'settings.navigation.admin.system.title' | translate }}</h3>
        @for (item of systemItems(); track item.labelKey) {
          <a class="admin-nav__item" [routerLink]="item.route" routerLinkActive="admin-nav__item--active"
            [routerLinkActiveOptions]="{ exact: true }">
            <span>{{ item.labelKey | translate }}</span>
          </a>
        }
      </section>
    }
  </div>

  <button type="button" class="admin-nav__switch" (click)="onSettingsRequested()">
    <app-icon icon="icon-eye-off-regular.svg" color="currentColor" [width]="20" [height]="20" aria-hidden="true" />
    <span>{{ 'settings.navigation.actions.settings' | translate }}</span>
  </button>
</nav>
